import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

export const metricKeys = [
  "respiration_rate",
  "movement",
  "time_asleep",
  "sleep_score",
  "out_of_bed",
] as const;

const texts = {
  respiration_rate: {
    increased: "Increased nocturnal respiratory rate",
    decreased: "Decreased nocturnal respiratory rate",
  },
  movement: {
    increased: "Increased movement during the night",
    decreased: "Decreased movement during the night",
  },
  time_asleep: {
    increased: "Increased total sleep time",
    decreased: "Reduced total sleep time",
  },
  sleep_score: {
    increased: "Increased sleep quality",
    decreased: "Reduced sleep quality",
  },
  out_of_bed: {
    increased: "Increased number of out-of-bed events",
    decreased: "Reduced number of out-of-bed events",
  },
} as const;

type DeviationTextProps = {
  metric: DeviationMetric;
};

export function DeviationText({ metric }: DeviationTextProps): string {
  const { t } = useTranslation();

  if (!metric.deviation) {
    return "";
  }

  if (metric.deviation > 0) {
    return t(texts[metric.id].increased);
  }

  return t(texts[metric.id].decreased);
}

export type DeviationMetric = NightReportMetric & {
  id: (typeof metricKeys)[number];
  key: string;
  value: number | undefined;
};
